import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./translations";

const STORAGE_KEY = "ciapum_lang";

function detectInitial() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "it" || stored === "en") return stored;
    } catch (e) { /* ignore */ }
    const nav = ((typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "it").toLowerCase();
    return nav.startsWith("it") ? "it" : "en";
}

i18n.use(initReactI18next).init({
    resources: { en: { translation: en } },
    lng: detectInitial(),
    fallbackLng: "it",
    supportedLngs: ["it", "en"],
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
});

export function setLanguage(lng) {
    const v = lng === "en" ? "en" : "it";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) { /* ignore */ }
    i18n.changeLanguage(v);
    return v;
}

// Localized name for backend objects that carry { name, name_en }
export function catName(obj) {
    if (!obj) return "";
    const en = (i18n.language || "it").startsWith("en");
    return en && obj.name_en ? obj.name_en : obj.name;
}

// Locale string for date/number formatting based on the active language
export function dateLocale() {
    return (i18n.language || "it").startsWith("en") ? "en-US" : "it-IT";
}

// Pick between an Italian value and its English counterpart
export function pickLang(itVal, enVal) {
    const en = (i18n.language || "it").startsWith("en");
    return en && enVal ? enVal : itVal;
}

export default i18n;
